module.exports = __webpack_public_path__ + "img/ic_cadastro_azul.f3be68b9.svg";